module.exports = __webpack_public_path__ + "img/whitelogo.b1469dd9.svg";